// JavaScript code for acf_blocks/explore-our-solutions component
(($) => {

     "use strict";
     if ($('.acf-blocks-explore-our-solutions').length === 0) {
          return;
     }
     console.log("acf_blocks/explore-our-solutions scripts loaded...");

     $(_ => {
          if ($('.acf-blocks-explore-our-solutions .carousel-programmes').length === 0) return;
          $('.acf-blocks-explore-our-solutions .carousel-programmes').each(function () {
               const $programmesCarousel = $(this);
               const $btnPrevious = $(this).next(`.nav-carousel`).find('.btn-prev');
               const $btnNext = $(this).next(`.nav-carousel`).find('.btn-next');

               $btnPrevious.on('click', (e) => {
                    e.preventDefault();
                    $programmesCarousel.trigger('prev.owl.carousel');
               });
               $btnNext.on('click', (e) => {
                    e.preventDefault();
                    $programmesCarousel.trigger('next.owl.carousel');
               });

               // Disable the next or previous button if there are no items to scroll
               $programmesCarousel.on('changed.owl.carousel', (event) => {
                    const items = event.item.count;
                    const currentIndex = event.item.index;
                    const itemsPerPage = event.page.size ? event.page.size : items;
                    console.log('Owl Carousel changed event:', event);
                    console.log(`Items: ${items}, Current Index: ${currentIndex}, Items Per Page: ${itemsPerPage}`);

                    if (items <= itemsPerPage) {
                         $btnPrevious.prop('hidden', true);
                         $btnNext.prop('hidden', true);
                         return;
                    }

                    $btnPrevious.prop('hidden', false);
                    $btnNext.prop('hidden', false);
                    $btnPrevious.prop('disabled', currentIndex === 0);
                    $btnNext.prop('disabled', currentIndex + itemsPerPage >= items);
               });

               let maxItems = Math.min(6, $programmesCarousel.find('.carousel-item').length);
               console.log(`Max items to show: ${maxItems}`);

               // Initialize the carousel
               $programmesCarousel.owlCarousel({
                    loop: false,
                    margin: 20,
                    nav: false,
                    dots: false,
                    stagePadding: 100,
                    responsive: {
                         0: {
                              items: 1,
                              stagePadding: 20
                         },
                         590: {
                              items: 2,
                              stagePadding: 20
                         },
                         850: {
                              items: 3,
                              stagePadding: 20
                         },
                         1200: {
                              items: 4,
                              stagePadding: 50
                         },
                         1600: {
                              items: (maxItems < 5) ? maxItems : 5
                         },
                         1950: {
                              items: maxItems
                         },
                    }
               });
          });
     });

})(jQuery);